import React from 'react';
import * as Form from 'react-hook-form';
import { Keyboard } from 'react-native';
import { t } from '@lingui/macro';

import AddPostComment from '@src/api/AddPostComment';
import { shortTimeout as timeout } from '@src/configuration/constants';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import { i18n, i18yup } from '@src/i18n';

import { CommentFormData } from './types';

const useCommentForm = (id?: string) => {
  const [loading, setLoading] = React.useState(false);
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const form = Form.useForm<CommentFormData>({
    validationSchema: i18yup.object<CommentFormData>({
      content: i18yup
        .string()
        .required()
        .label(i18n._(t`Content`)),
    }),
  });

  const handleSubmit = React.useCallback(
    async ({ content }: CommentFormData) => {
      if (!id) {
        return;
      }
      try {
        Keyboard.dismiss();
        setLoading(true);
        await AddPostComment(
          accessToken,
          {
            entityId: id,
            comment: content,
          },
          { timeout }
        );
        setLoading(false);
        form.reset({ content: '' });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    },
    [accessToken, form, id]
  );

  return React.useMemo(
    () => ({
      form,
      handleSubmit: form.handleSubmit(handleSubmit),
      loading,
    }),
    [form, handleSubmit, loading]
  );
};

export default useCommentForm;
